import React from 'react';
import './i18n';
import Router from './Router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.css';
import './styles/bs4-bridge.scss';
import './styles/App.scss';
import 'react-loading-skeleton/dist/skeleton.css'
import storeObj from './store/configureStore/store';

const { store, persistor } =storeObj;

function App() {
  if (process.env.REACT_APP_ENVIRONMENT === "production")
  console.log = function no_console() {};
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="main-wrapper-section">
          <Router />
        </div>
        <ToastContainer autoClose={3000} theme="colored" />
      </PersistGate>
    </Provider>
  );
}

export default App;
